/** Pricing copy in Arabic. Mirrors `../../en/home/pricing.js` key for key. */
import { GET_STARTED_URL } from '@/data/links'

export const PRICING = {
  eyebrow: 'الأسعار',
  title: 'باقات لكل مكتب',
  note: 'جميع الأسعار بالريال السعودي ولا تشمل ضريبة القيمة المضافة.',
  billing: [
    { id: 'monthly', label: 'شهري', unit: 'ريال / شهريًا' },
    { id: 'yearly', label: 'سنوي', unit: 'ريال / سنويًا' },
  ],
  free: 'مجاني',
  plans: [
    {
      name: 'المجانية',
      icon: 'calendar',
      description: 'جرّب كل شيء.',
      price: { monthly: 0, yearly: 0 },
      freeNote: '14 يومًا',
      users: 'حتى 10 مستخدمين',
      features: [
        'قاعة واحدة',
        'الرسائل',
        'تقويم Google وMeet',
        'دعوة الضيوف',
        'دعم ذو أولوية',
      ],
      cta: { label: 'ابدأ مجانًا', href: GET_STARTED_URL },
    },
    {
      name: 'الأساسية',
      icon: 'user',
      description: 'للفرق الصغيرة.',
      price: { monthly: 149, yearly: 1788 },
      users: 'حتى 10 مستخدمين',
      features: [
        'قاعة واحدة',
        'مسؤولان',
        '1,000 رسالة اجتماع شهريًا',
        'الرسائل',
        'الموارد البشرية والاستقبال',
      ],
      cta: { label: 'اختر الأساسية', href: `${GET_STARTED_URL}?plan=basic` },
    },
    {
      name: 'الأعمال',
      icon: 'users',
      description: 'الأكثر شيوعًا.',
      price: { monthly: 399, yearly: 4788 },
      users: 'حتى 40 مستخدمًا',
      features: [
        '4 قاعات',
        '5 مسؤولين',
        'تقويم Google وMeet',
        '20 دعوة ضيف',
        'دعم ذو أولوية',
      ],
      cta: { label: 'اختر الأعمال', href: `${GET_STARTED_URL}?plan=business` },
      featured: true,
    },
    {
      name: 'المؤسسات',
      icon: 'building',
      description: 'لجميع الفروع.',
      price: { monthly: 799, yearly: 9588 },
      users: 'حتى 150 مستخدمًا',
      features: [
        '12 قاعة',
        '10 مسؤولين',
        'مدير حساب مخصص',
        'رسائل بلا حدود',
        'كل الميزات',
      ],
      cta: { label: 'اختر المؤسسات', href: `${GET_STARTED_URL}?plan=enterprise` },
    },
  ],
}
